export interface AppConfig {
  minimalScoreToApply: number;
  cvAnalysis: {
    minimalScoreToApply: number;
    pollingIntervalMs: number;
  };
  gqlApiUrl: string;
  portalRootId: string;
  sentryDsn: string;
  RUMApplicationId: string;
  cognito: {
    linkedInCustomProviderName: string;
    region: string;
    userPoolId: string;
    clientId: string;
    domain: string;
    redirectSignIn: string;
    redirectSignOut: string;
  };
  google: {
    autocompleteKey: string;
    recaptchaKey: string;
  };
  realtimerUrl: string;
  airporterUrl: string;
  jobBoardUrl: string;
  discordUrl: string;
  whistleblowerPolicyUrl: string;
  oldTermsAndPrivacyPolicyUrl: string;
  newTermsUrl: string;
  newPrivacyPolicyUrl: string;
  cv: {
    maxSize: number;
    minSize: number;
    acceptedTypes: string[];
  };
  allowUserWithFinishedOnboardingBackToOnboarding: boolean;
  airConversation: {
    issueReportMessageMaxLength: number;
    durationInMinutes: number;
    showPreAirMessage: boolean;
    preAirMessageDisplayTimeInMs: number;
  };
  meetingDatePickerMaxDays: number;
  disableConsoleLog: boolean;
  environmentIndicatorColor: string;
  environmentIndicatorLabel: string;
  airPromoVideo1: string;
  airPromoVideo2: string;
  englishLanguageId: string;
}

export const appConfig: AppConfig = {
  minimalScoreToApply: Number(import.meta.env.VITE_MINIMAL_SCORE_TO_APPLY ?? 0),
  cvAnalysis: {
    minimalScoreToApply: Number(import.meta.env.VITE_MINIMAL_CV_ANALYSIS_SCORE_TO_APPLY ?? 4),
    pollingIntervalMs: Number(import.meta.env.VITE_CV_ANALYSIS_POLLING_INTERVAL_MS ?? 10_000),
  },
  gqlApiUrl: import.meta.env.VITE_GRAPHQL_API_URL || 'http://localhost:4000/graphql',
  jobBoardUrl: import.meta.env.VITE_JOB_BOARD_URL,
  portalRootId: 'portal-root',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  RUMApplicationId: import.meta.env.VITE_RUM_APPLICATION_ID,
  cognito: {
    linkedInCustomProviderName: import.meta.env.VITE_COGNITO_LINKED_IN_CUSTOM_PROVIDER_NAME,
    region: import.meta.env.VITE_COGNITO_REGION,
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
    domain: import.meta.env.VITE_COGNITO_DOMAIN,
    redirectSignIn: import.meta.env.VITE_COGNITO_REDIRECT_SIGN_IN,
    redirectSignOut: import.meta.env.VITE_COGNITO_REDIRECT_SIGN_OUT,
  },
  google: {
    autocompleteKey: import.meta.env.VITE_GOOGLE_AUTOCOMPLETE_KEY,
    recaptchaKey: import.meta.env.VITE_GOOGLE_RECAPTCHA_KEY,
  },
  realtimerUrl: import.meta.env.VITE_REALTIMER_URL ?? 'https://api.dev.c-hub.hoq.us',
  airporterUrl: import.meta.env.VITE_AIRPORTER_URL ?? 'https://airporter.dev.air.connectis.pl',
  discordUrl: import.meta.env.VITE_DISCORD_URL,
  whistleblowerPolicyUrl:
    'https://connectis-legal.s3.eu-central-1.amazonaws.com/Connectis_Procedura_zgloszen_naruszen_prawa.pdf',
  oldTermsAndPrivacyPolicyUrl:
    'https://connectis-legal.s3.eu-central-1.amazonaws.com/Connectis_Hub_Regulamin_od_2023_06_07.pdf',
  newTermsUrl:
    'https://connectis-legal.s3.eu-central-1.amazonaws.com/Connectis_Hub_Regulamin_od_2025_09_02.pdf',
  newPrivacyPolicyUrl:
    'https://connectis-legal.s3.eu-central-1.amazonaws.com/Connectis_Hub_Polityka_Prywatnosci_od_2025_09_02.pdf',
  cv: {
    maxSize: 5000000,
    minSize: 1,
    acceptedTypes: [
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.openxmlformats',
      'application/doc',
      'application/ms-doc',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ],
  },
  allowUserWithFinishedOnboardingBackToOnboarding:
    import.meta.env.VITE_ALLOW_USERS_WITH_FINISHED_ONBOARDING_BACK_TO_ONBOARDING === 'true',
  airConversation: {
    issueReportMessageMaxLength: 500,
    durationInMinutes: Number(import.meta.env.VITE_AIR_CONVERSATION_IN_MINUTES ?? 30),
    showPreAirMessage: import.meta.env.VITE_SHOW_PRE_AIR_MESSAGE === 'true',
    preAirMessageDisplayTimeInMs: Number(
      import.meta.env.VITE_PRE_AIR_MESSAGE_DISPLAY_TIME_MS ?? 10_000,
    ),
  },
  meetingDatePickerMaxDays: 5,
  disableConsoleLog: import.meta.env.VITE_DISABLE_CONSOLE_LOG === 'true',
  environmentIndicatorColor: import.meta.env.VITE_ENVIRONMENT_INDICATOR_COLOR,
  environmentIndicatorLabel: import.meta.env.VITE_ENVIRONMENT_INDICATOR_LABEL,
  airPromoVideo1: 'https://connectis-air.s3.eu-central-1.amazonaws.com/air-promo-1.mp4',
  airPromoVideo2: 'https://connectis-air.s3.eu-central-1.amazonaws.com/air-promo-2.mp4',
  englishLanguageId: import.meta.env.VITE_ENGLISH_LANGUAGE_ID ?? '',
};
